import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, change } from 'redux-form';
import Money from '../../../../common/money';
import Tooltip from '../../../../common/PortalledTooltip';

const BARBER_FORM = 'barberForm';

const Service = ({ serviceName, index, serviceId, defaultServiceId, enabled, setDefaultService, visibleOnline }) => {
  const name = field => (
    <div className="c-paragraph u-pr-">{ field.input.value || '' }</div>
  );

  const serviceType = field => (
    <div className="c-paragraph u-pr- u-first-letter-capitalize">{ field.input.value }</div>
  );

  const cost = (field) => {
    const price = field.input.value ? <Money cents={field.input.value} /> : '';
    return (
      <div className="c-paragraph u-pr-">{ price }</div>
    );
  };

  const duration = (field) => {
    const min = field.input.value ? `${field.input.value} min` : '';
    return (
      <div className="c-paragraph u-pr-">{ min }</div>
    );
  };

  return (
    <div className="c-table-card__row">
      <div className="c-table-card__cell">
        <Field
          name={`${serviceName}.createdBy`}
          component={serviceType}
        />
      </div>
      <div className="c-table-card__cell">
        <Field
          name={`${serviceName}.name`}
          component={name}
        />
      </div>
      <div className="c-table-card__cell">
        <Field
          name={`${serviceName}.cost`}
          component={cost}
        />
      </div>
      <div className="c-table-card__cell">
        <Field
          name={`${serviceName}.duration`}
          component={duration}
        />
      </div>
      <div className="c-table-card__cell">
        <div className="u-flex u-align-items-center">
          <div className="c-switch">
            <Field
              name={`${serviceName}.enabled`}
              id={`service-${index}`}
              className="c-switch__toggle"
              component="input"
              type="checkbox"
              normalize={value => serviceId === defaultServiceId || value || false}
            />
            <label
              className="c-switch__label"
              htmlFor={`service-${index}`}
            />
          </div>
          <Tooltip
            className="u-type--no-transform c-info-tooltip-new--form"
            display-if={!visibleOnline}
          >
            <div className="u-m--">
              This service is not enabled for online visibility. For this service to be bookable for this staff member,
              please enable it for online visibility.
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="c-table-card__cell u-text-center">
        <label className="c-radio">
          <Field
            name="defaultServiceId"
            component="input"
            type="radio"
            value={serviceId}
            className="c-radio__input"
            onClick={(e) => {
              if (e.target.value === defaultServiceId) setDefaultService(null);
            }}
            disabled={!enabled}
          />
          <span className="c-radio__trigger" />
        </label>
      </div>
      <Field
        name={`${serviceName}.id`}
        component="input"
        type="hidden"
      />
    </div>
  );
};
Service.propTypes = {
  serviceName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  serviceId: PropTypes.string.isRequired,
  defaultServiceId: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  setDefaultService: PropTypes.func.isRequired,
  visibleOnline: PropTypes.bool.isRequired,
};
Service.defaultProps = {
  defaultServiceId: null,
};

const selector = formValueSelector(BARBER_FORM);
const mapStateToProps = (state, ownProps) => ({
  serviceId: (selector(state, ownProps.serviceName) || {}).id,
  defaultServiceId: selector(state, 'defaultServiceId'),
  enabled: selector(state, `${ownProps.serviceName}.enabled`),
  visibleOnline: selector(state, `${ownProps.serviceName}.visibleOnline`),
});
const mapDispatchToProps = dispatch => bindActionCreators({
  setDefaultService: value => change(BARBER_FORM, 'defaultServiceId', value),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Service);
